import { render, staticRenderFns } from "./arrayAnswerCard.vue?vue&type=template&id=6c9b0166&"
import script from "./arrayAnswerCard.vue?vue&type=script&lang=js&"
export * from "./arrayAnswerCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports